import ranger from "../assets/ranger.jpeg"
import mcls from "../assets/2005_Mercedes-Benz_CLS_320_CDi_Automatic_3.0_Rear.jpg"
import audiq7 from "../assets/audiq7.jpg"
import audia7 from "../assets/2015-audi-a7-30-tfsi-quattro-progressiv_1.png"
import camry from "../assets/toyota camry.jpeg"
import minic from "../assets/minic.jpeg"
import bmw from "../assets/2023bmw.jpeg"
import mits from "../assets/Mitsubishi_ASX_front_20100717.jpg"
import peugeot from "../assets/peugeot.jpg"
import chev from "../assets/chevrolet.jpeg"
import bmw320i from "../assets/2024-bmw-320i.png"
import mercedesC200 from "../assets/2024-mercedes-c200.png"
import audiA5 from "../assets/2024-audi-a5.png"
import toyotaRav4 from "../assets/2024-toyota-rav4.png"
import hondaCrv from "../assets/2024-honda-crv.png"
import teslaModel3 from "../assets/2024-tesla-model3.png"
import volvoXc60 from "../assets/2024-volvo-xc60.png"
import porscheMacan from "../assets/2024-porsche-macan.png"
import fordMustang from "../assets/2024-ford-mustang.png"
import vwGolfGti from "../assets/2024-vw-golf-gti.png"

export const CarData = [
    {
        id:1,
        name:"2016 LAND ROVER RANGE ROVER AUTOBIOGRAPHI 3.0 DİZEL HYIBRID",
        img:ranger,
        price:"55000",
        year:"2016",
        body:"SUV",
        Cylinder:"6 Cylinder",
        Color:"Black"
    },
    {
        id:2,
        name:"2005 MERCEDES CLS 320 CDI",
        img:mcls,
        price:"9000",
        year:"2015",
        body:"Sedan",
        Cylinder:"4 Cylinder",
        Color:"Black"
    },
    {
        id:3,
        name:"2014 AUDI Q7 3.0 T QUATTRO 7 SEATER",
        img:audiq7,
        price:"19000",
        year:"2014",
        body:"SUV",
        Cylinder:"6 Cylinder",
        Color:"White"
    },
    {
        id:4,
        name:"2015 AUDI A7 3.0 TFSI QUATTRO S-LINE ",
        img:audia7,
        price:"31000",
        year:"2015",
        body:"Coupe",
        Cylinder:"6 Cylinder",
        Color:"Grey"
    },
    {
        id:5,
        name:"2023 TOYOTA CAMMRY HYBRITH 2.5",
        img:camry,
        price:"40000",
        year:"2023",
        body:"Sedan",
        Cylinder:"4 Cylinder",
        Color:"Black"
    },
    {
        id:6,
        name:"2022 MINI COOPER 1.5",
        img:minic,
        price:"30000",
        year:"2022",
        body:"5 Door Hatchback",
        Cylinder:"4 Cylinder",
        Color:"Black"
    },
    {
        id:7,
        name:"2023 BMW X1 sDrive 18i M Sport",
        img:bmw,
        price:"45000",
        year:"2023",
        body:"SUV",
        Cylinder:"4 Cylinder",
        Color:"White"
    },
    {
        id:8,
        name:"2012 MITSUBISHI ASX1.6",
        img:mits,
        price:"11000",
        year:"2012",
        body:"SUV",
        Cylinder:"4 Cylinder",
        Color:"Black"
    },
    {
        id:9,
        name:"2010 PEUGEOT 3008 1.6",
        img:peugeot,
        price:"9000",
        year:"2010",
        body:"SUV",
        Cylinder:"4 Cylinder",
        Color:"Grey"
    },
    {
        id:10,
        name:"2014 CHEVROLET CRUİZE 1.4",
        img:chev,
        price:"10000",
        year:"2014",
        body:"Sedan",
        Cylinder:"4 Cylinder",
        Color:"Red"
    },
    {
        id:11,
        name:"2024 BMW 320i SEDAN",
        img:bmw320i,
        price:"48000",
        year:"2024",
        body:"Sedan",
        Cylinder:"4 Cylinder",
        Color:"Dark Blue"
    },
    {
        id:12,
        name:"2024 MERCEDES-BENZ C 200",
        img:mercedesC200,
        price:"50000",
        year:"2024",
        body:"Sedan",
        Cylinder:"4 Cylinder",
        Color:"White"
    },
    {
        id:13,
        name:"2024 AUDI A5 SPORTBACK 35 TFSI",
        img:audiA5,
        price:"49000",
        year:"2024",
        body:"Sportback",
        Cylinder:"4 Cylinder",
        Color:"Grey"
    },
    {
        id:14,
        name:"2024 TOYOTA RAV4 2.5",
        img:toyotaRav4,
        price:"39000",
        year:"2024",
        body:"SUV",
        Cylinder:"4 Cylinder",
        Color:"Green"
    },
    {
        id:15,
        name:"2024 HONDA CR-V 1.5 TURBO",
        img:hondaCrv,
        price:"41000",
        year:"2024",
        body:"SUV",
        Cylinder:"4 Cylinder",
        Color:"Red"
    },
    {
        id:16,
        name:"2024 TESLA MODEL 3 LONG RANGE",
        img:teslaModel3,
        price:"42000",
        year:"2024",
        body:"Sedan",
        Cylinder:"Electric",
        Color:"White"
    },
    {
        id:17,
        name:"2024 VOLVO XC60 B5 AWD",
        img:volvoXc60,
        price:"65000",
        year:"2024",
        body:"SUV",
        Cylinder:"4 Cylinder",
        Color:"Silver"
    },
    {
        id:18,
        name:"2024 PORSCHE MACAN",
        img:porscheMacan,
        price:"90000",
        year:"2024",
        body:"SUV",
        Cylinder:"4 Cylinder",
        Color:"Turquoise"
    },
    {
        id:19,
        name:"2024 FORD MUSTANG GT 5.0",
        img:fordMustang,
        price:"62000",
        year:"2024",
        body:"Coupe",
        Cylinder:"8 Cylinder",
        Color:"Blue"
    },
    {
        id:20,
        name:"2024 VOLKSWAGEN GOLF GTI",
        img:vwGolfGti,
        price:"48000",
        year:"2024",
        body:"5 Door Hatchback",
        Cylinder:"4 Cylinder",
        Color:"Red"
    }
]
